import { ISetCartLoyalty } from "action/interfaces/shopping-cart.interface";
import { ICartLoyalty } from "api/interfaces/shoping-cart.type";

export function setCartLoyalty(data: ICartLoyalty | null): ISetCartLoyalty {
  const defaultData = {
    selectedLoyaltyPoints: null,
    loyaltyPointsBalance: null,
    cartLoyaltyValue: null,
    entireOrderCoveredByLoyaltyPoints: false,
  };

  return {
    type: "SET_CART_LOYALTY",
    data: data || defaultData,
  };
}
